import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Legal = props => {
  const className = classnames('legal', props.className);

  return (
    <div className={className}>
      &copy; Huggg Limited, registered in England and Wales Company #09579886.
      Registered office Runway East Bristol, 1 Victoria St, Bristol BS1 6AA.
    </div>
  );
};

Legal.propTypes = {
  className: PropTypes.string
};

export default Legal;
